import { AttributesConfigurationDc, PostgresLayerServiceConfigurationDc } from "@evergis/api";
import { LayerInfo } from "../../../interfaces/resourceInfo";

export function removeColumnsFromLayerConfiguration(
  layer: LayerInfo,
  columnsDelete: string[],
): PostgresLayerServiceConfigurationDc {
  const { layerAttributes, configuration, name } = layer || {};
  const { attributesConfiguration } = configuration || {};

  return {
    ...configuration,
    name,
    attributesConfiguration: {
      ...(attributesConfiguration || {}),
      attributes: [...(layerAttributes.filter(({ attributeName }) => !columnsDelete.includes(attributeName)) || [])],
    } as AttributesConfigurationDc,
  };
}
